module.exports = __webpack_public_path__ + "static/media/female-circle.1917ad5d.png";